// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scope all styles to the Excel sheet modal only */

/* Ensure the modal itself has the highest z-index */
.excel-sheet-modal {
    z-index: 1070 !important; /* Higher than typical sidebars (1050-1060) */
}

.excel-sheet-modal .modal-dialog {
    z-index: 1071 !important;
}

.excel-sheet-modal .modal-content {
    z-index: 1072 !important;
}

/* Table container styles */
.excel-sheet-modal .table-container {
    overflow-x: auto;
    max-height: 70vh; /* Add vertical scrolling for very tall tables */
    overflow-y: auto;
    z-index: 1;
    position: relative;
}

.excel-sheet-modal .table-container table {
    width: 80%;
    border-collapse: collapse;
    min-width: max-content; /* Ensure table doesn't compress when there are many columns */
    table-layout: auto; /* Let browser optimize column widths */
    position: relative;
    z-index: 1;
}

.excel-sheet-modal .table-container table th, 
.excel-sheet-modal .table-container table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left; /* Left align text for better readability */
    min-width: 80px; /* Minimum width for each cell to ensure readability */
    max-width: 200px; /* Maximum width to force wrapping for long content */
    white-space: normal; /* Allow text wrapping */
    word-wrap: break-word; /* Break long words if necessary */
    vertical-align: top; /* Align content to top when multi-line */
    line-height: 1.4; /* Better line spacing for multi-line content */
}

.excel-sheet-modal .table-container table th {
    background-color: #f0f0f0;
    position: sticky;
    top: 0; /* Make header sticky when scrolling vertically */
    z-index: 20; /* Higher z-index for sticky headers */
}

/* Make first column (row numbers) sticky when scrolling horizontally */
.excel-sheet-modal .table-container table th:first-child,
.excel-sheet-modal .table-container table td:first-child {
    position: sticky;
    left: 0;
    background-color: #f0f0f0;
    z-index: 15; /* Higher z-index for sticky first column */
    font-weight: bold;
    text-align: center; /* Keep row numbers centered */
    white-space: nowrap; /* Row numbers should not wrap */
    min-width: 50px;
    max-width: 60px;
}

/* Ensure the top-left corner cell has highest z-index */
.excel-sheet-modal .table-container table th:first-child {
    z-index: 25; /* Highest z-index for corner cell */
}

/* Modal backdrop should also have high z-index */
.excel-sheet-modal .modal-backdrop {
    z-index: 1069 !important;
}

.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border: 1px solid #ccc;
    padding: 20px;
    z-index: 1080; /* Even higher for nested modals */
}

.modal-content {
    display: flex;
    flex-direction: column;
}

textarea {
    width: 100%;
    height: 100px;
    margin-bottom: 10px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
}

.modal-actions button {
    margin-left: 10px;
    padding: 5px 10px;
}

/* Additional styles for better Excel-like experience */
.excel-sheet-modal .modal-dialog {
    max-width: 75vw !important; /* Use more screen space for wide tables */
    margin: 1rem auto;
}

.excel-sheet-modal .modal-body {
    padding: 0; /* Remove padding to maximize table space */
}

/* Hover effects for better UX */
.excel-sheet-modal tbody tr:hover {
    background-color: rgba(0, 123, 255, 0.1);
}

.excel-sheet-modal tbody td:hover {
    background-color: rgba(0, 123, 255, 0.2) !important;
    cursor: pointer;
}

/* Style for highlighted cells */
.excel-sheet-modal .highlighted-cell {
    background-color: #FFFFCC !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .excel-sheet-modal th, 
    .excel-sheet-modal td {
        min-width: 60px;
        max-width: 150px; /* Smaller max width on mobile */
        padding: 4px;
        font-size: 12px;
    }
    
    .excel-sheet-modal .modal-dialog {
        max-width: 95vw !important;
        margin: 0.5rem auto;
    }
}

/* Additional utility classes for different content types */
.excel-sheet-modal .numeric-cell {
    text-align: right !important;
    white-space: nowrap !important;
}

.excel-sheet-modal .header-cell {
    text-align: center !important;
    font-weight: bold;
    background-color: #f8f9fa !important;
}

.excel-sheet-modal .text-cell {
    text-align: left !important;
    white-space: normal !important;
}

/* Improve readability of wrapped text */
.excel-sheet-modal td {
    line-height: 1.5;
    word-break: break-word;
}

/* Adjust table layout for better column distribution */
.excel-sheet-modal table {
    table-layout: auto; /* Let browser optimize column widths */
}

/* Force modal to appear above everything */
.excel-sheet-modal.show {
    z-index: 1070 !important;
}

.excel-sheet-modal.show .modal-dialog {
    z-index: 1071 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/forms/tables/XlsxTable.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD,oDAAoD;AACpD;IACI,wBAAwB,EAAE,6CAA6C;AAC3E;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,gBAAgB,EAAE,gDAAgD;IAClE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,sBAAsB,EAAE,8DAA8D;IACtF,kBAAkB,EAAE,uCAAuC;IAC3D,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB,EAAE,2CAA2C;IAC7D,eAAe,EAAE,sDAAsD;IACvE,gBAAgB,EAAE,qDAAqD;IACvE,mBAAmB,EAAE,wBAAwB;IAC7C,qBAAqB,EAAE,kCAAkC;IACzD,mBAAmB,EAAE,yCAAyC;IAC9D,gBAAgB,EAAE,+CAA+C;AACrE;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,MAAM,EAAE,iDAAiD;IACzD,WAAW,EAAE,sCAAsC;AACvD;;AAEA,uEAAuE;AACvE;;IAEI,gBAAgB;IAChB,OAAO;IACP,yBAAyB;IACzB,WAAW,EAAE,2CAA2C;IACxD,iBAAiB;IACjB,kBAAkB,EAAE,8BAA8B;IAClD,mBAAmB,EAAE,gCAAgC;IACrD,eAAe;IACf,eAAe;AACnB;;AAEA,wDAAwD;AACxD;IACI,WAAW,EAAE,oCAAoC;AACrD;;AAEA,iDAAiD;AACjD;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,aAAa,EAAE,kCAAkC;AACrD;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,uDAAuD;AACvD;IACI,0BAA0B,EAAE,0CAA0C;IACtE,iBAAiB;AACrB;;AAEA;IACI,UAAU,EAAE,2CAA2C;AAC3D;;AAEA,gCAAgC;AAChC;IACI,wCAAwC;AAC5C;;AAEA;IACI,mDAAmD;IACnD,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;IACI;;QAEI,eAAe;QACf,gBAAgB,EAAE,gCAAgC;QAClD,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;AACJ;;AAEA,2DAA2D;AAC3D;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA,wCAAwC;AACxC;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,uDAAuD;AACvD;IACI,kBAAkB,EAAE,uCAAuC;AAC/D;;AAEA,2CAA2C;AAC3C;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["/* Scope all styles to the Excel sheet modal only */\n\n/* Ensure the modal itself has the highest z-index */\n.excel-sheet-modal {\n    z-index: 1070 !important; /* Higher than typical sidebars (1050-1060) */\n}\n\n.excel-sheet-modal .modal-dialog {\n    z-index: 1071 !important;\n}\n\n.excel-sheet-modal .modal-content {\n    z-index: 1072 !important;\n}\n\n/* Table container styles */\n.excel-sheet-modal .table-container {\n    overflow-x: auto;\n    max-height: 70vh; /* Add vertical scrolling for very tall tables */\n    overflow-y: auto;\n    z-index: 1;\n    position: relative;\n}\n\n.excel-sheet-modal .table-container table {\n    width: 80%;\n    border-collapse: collapse;\n    min-width: max-content; /* Ensure table doesn't compress when there are many columns */\n    table-layout: auto; /* Let browser optimize column widths */\n    position: relative;\n    z-index: 1;\n}\n\n.excel-sheet-modal .table-container table th, \n.excel-sheet-modal .table-container table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left; /* Left align text for better readability */\n    min-width: 80px; /* Minimum width for each cell to ensure readability */\n    max-width: 200px; /* Maximum width to force wrapping for long content */\n    white-space: normal; /* Allow text wrapping */\n    word-wrap: break-word; /* Break long words if necessary */\n    vertical-align: top; /* Align content to top when multi-line */\n    line-height: 1.4; /* Better line spacing for multi-line content */\n}\n\n.excel-sheet-modal .table-container table th {\n    background-color: #f0f0f0;\n    position: sticky;\n    top: 0; /* Make header sticky when scrolling vertically */\n    z-index: 20; /* Higher z-index for sticky headers */\n}\n\n/* Make first column (row numbers) sticky when scrolling horizontally */\n.excel-sheet-modal .table-container table th:first-child,\n.excel-sheet-modal .table-container table td:first-child {\n    position: sticky;\n    left: 0;\n    background-color: #f0f0f0;\n    z-index: 15; /* Higher z-index for sticky first column */\n    font-weight: bold;\n    text-align: center; /* Keep row numbers centered */\n    white-space: nowrap; /* Row numbers should not wrap */\n    min-width: 50px;\n    max-width: 60px;\n}\n\n/* Ensure the top-left corner cell has highest z-index */\n.excel-sheet-modal .table-container table th:first-child {\n    z-index: 25; /* Highest z-index for corner cell */\n}\n\n/* Modal backdrop should also have high z-index */\n.excel-sheet-modal .modal-backdrop {\n    z-index: 1069 !important;\n}\n\n.modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 20px;\n    z-index: 1080; /* Even higher for nested modals */\n}\n\n.modal-content {\n    display: flex;\n    flex-direction: column;\n}\n\ntextarea {\n    width: 100%;\n    height: 100px;\n    margin-bottom: 10px;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.modal-actions button {\n    margin-left: 10px;\n    padding: 5px 10px;\n}\n\n/* Additional styles for better Excel-like experience */\n.excel-sheet-modal .modal-dialog {\n    max-width: 75vw !important; /* Use more screen space for wide tables */\n    margin: 1rem auto;\n}\n\n.excel-sheet-modal .modal-body {\n    padding: 0; /* Remove padding to maximize table space */\n}\n\n/* Hover effects for better UX */\n.excel-sheet-modal tbody tr:hover {\n    background-color: rgba(0, 123, 255, 0.1);\n}\n\n.excel-sheet-modal tbody td:hover {\n    background-color: rgba(0, 123, 255, 0.2) !important;\n    cursor: pointer;\n}\n\n/* Style for highlighted cells */\n.excel-sheet-modal .highlighted-cell {\n    background-color: #FFFFCC !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .excel-sheet-modal th, \n    .excel-sheet-modal td {\n        min-width: 60px;\n        max-width: 150px; /* Smaller max width on mobile */\n        padding: 4px;\n        font-size: 12px;\n    }\n    \n    .excel-sheet-modal .modal-dialog {\n        max-width: 95vw !important;\n        margin: 0.5rem auto;\n    }\n}\n\n/* Additional utility classes for different content types */\n.excel-sheet-modal .numeric-cell {\n    text-align: right !important;\n    white-space: nowrap !important;\n}\n\n.excel-sheet-modal .header-cell {\n    text-align: center !important;\n    font-weight: bold;\n    background-color: #f8f9fa !important;\n}\n\n.excel-sheet-modal .text-cell {\n    text-align: left !important;\n    white-space: normal !important;\n}\n\n/* Improve readability of wrapped text */\n.excel-sheet-modal td {\n    line-height: 1.5;\n    word-break: break-word;\n}\n\n/* Adjust table layout for better column distribution */\n.excel-sheet-modal table {\n    table-layout: auto; /* Let browser optimize column widths */\n}\n\n/* Force modal to appear above everything */\n.excel-sheet-modal.show {\n    z-index: 1070 !important;\n}\n\n.excel-sheet-modal.show .modal-dialog {\n    z-index: 1071 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
